export const menuList = [
  {
    title: '数据统计',
    path: '/dashboard',
    icon: 'el-icon-data-line',
    code: 'queryDataStatistics'
  },
  {
    title: '资产类型管理',
    path: '/asset-type',
    icon: 'el-icon-folder',
    code: 'queryAssetType'
  },
  {
    title: '资产管理',
    path: '/asset',
    icon: 'el-icon-office-building',
    children: [
      {
        title: '资产入库',
        path: '/asset/storage',
        code: 'addAssetData'
      },
      {
        title: '资产列表',
        path: '/asset/list',
        code: 'queryAssetData'
      }
    ]
  },
  {
    title: '资产维修记录',
    path: '/repair',
    icon: 'el-icon-document',
    code: 'queryAssetMaintenanceRecord'
  },
  {
    title: '操作日志',
    path: '/operation-log',
    icon: 'el-icon-document-copy',
    code: 'queryOperationLog'
  },
  {
    title: '系统管理',
    path: '/system',
    icon: 'el-icon-setting',
    children: [
      {
        title: '角色管理',
        path: '/system/role',
        code: 'queryRole'
      },
      {
        title: '用户管理',
        path: '/system/user',
        code: 'queryAdmin'
      },
      {
        title: '控制单位管理',
        path: '/system/control-unit',
        code: 'queryControlUnit'
      },
      {
        title: '短信模板管理',
        path: '/system/sms-template',
        code: 'querySmsTemplate'
      },
      {
        title: '短信记录管理',
        path: '/system/sms-record',
        code: 'querySmsRecord'
      }
    ]
  }
] 